module.exports = __webpack_public_path__ + "static/bt-927ecffd501a46bd5bb3fe7cb8ef08e7.svg";